import { cn } from '@/lib/utils'
import logo from '@/assets/logo.png'

interface CoworkLogoProps {
  className?: string
  iconOnly?: boolean
}

// ใช้โลโก้จริง (src/assets/logo.png) แทน badge ตัวอักษร "JC" เดิม
// แยกเป็น component กลางเพื่อใช้ซ้ำในหน้า Login/Register/Navbar ให้ภาพเดียวกันทุกที่
export function CoworkLogo({ className, iconOnly = false }: CoworkLogoProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <img
        src={logo}
        alt="Jos CoWork"
        className={cn(
          'h-11 shrink-0 object-contain',
          iconOnly ? 'w-11' : 'w-auto'
        )}
      />
    </div>
  )
}
